import forge from 'node-forge';

export class CryptoService {
  secretKey: string = '';

  setSecretKey(secretKey: string) {
    this.secretKey = secretKey;
  }

  encryptData(data: any) {
    const newData = JSON.stringify(data);

    const cipher = forge.cipher.createCipher('3DES-ECB', forge.util.createBuffer(this.secretKey));
    cipher.start({ iv: '' });
    cipher.update(forge.util.createBuffer(newData, 'utf8'));
    cipher.finish();

    const encrypted = cipher.output;
    return forge.util.encode64(encrypted.getBytes());
  }

  decryptData(data: string) {
    const cipher = forge.cipher.createDecipher('3DES-ECB', forge.util.createBuffer(this.secretKey));

    const decodedData = forge.util.decode64(data);

    cipher.start({ iv: '' });
    cipher.update(forge.util.createBuffer(decodedData, 'raw'));
    cipher.finish();

    const decrypted = cipher.output.toString();

    return JSON.parse(decrypted);
  }
}
